import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import LoginLayout from '@/layouts/LoginLayout.vue'
import MockLogin from '@/layouts/MockLogin.vue'
import LogOut from '@/views/Logout.vue'
import Home from '@/views/Home.vue'
import Securities from '@/views/Securities.vue'
import Collections from '@/views/Collections.vue'
import CustomLocations from '@/views/CustomLocations.vue'
import Locations from '@/views/Locations.vue'
import ProcessSSO from '@/views/ProcessSSO'
import store from '@/store'

Vue.use(VueRouter)

// this method of using multiple application layouts is detailed here: https://nickescobedo.com/1252/easy-way-to-have-multiple-layouts-for-your-vue-js-app
const routes = [
  {
    path: '',
    name: 'App',
    component: AppLayout,
    children: [{
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/collections/:collection_id?',
      name: 'Collections',
      component: Collections,
    //   beforeEnter: (to,from,next)=>{
    //     let body = document.getElementById('body')
    //     body.style.scrollY='hidden';
    //     body.style.maxWidth = '100vh'

    // }
    },
    {
      path: '/securities/:cusip?',
      name: 'Securities',
      component: Securities
    },
    {
      path: '/locations',
      name: 'Locations',
      component: Locations
    },
    {
      path: '/custom_locations',
      name: 'CustomLocations',
      component: CustomLocations,
      alias: ['/geoanalyzer','/GeoAnalyzer','/esgg']
    },
    {
      path: '/welcome',
      name: 'Welcome',
      meta: {
        isPublic: true
      },
      component: ProcessSSO
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    }]
  },
  {
    path: '/mock-login',
    name: "Dev Login",
    component: MockLogin,
  },
  {
    path: '/auth',
    name: 'Auth',
    component: LoginLayout,
    meta: {
      isPublic: true
    },
    children: [
      {
        path: '/logout',
        name: 'LogOut',
        component: LogOut,
        beforeEnter: (to, from, next) => {

          store.dispatch('logout')
          router.app.$cookies.remove('t')

          next()

        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  /*
    Note: this VueRouter callback requires a user to be authenticated before they can navigate through the app.
    If not, they are redirected to the login page (in production) or a user select page (in dev).
    This is not meant to be bulletproof access control mechanism. The assumption is that this Vue app will lean on server-side API calls authenticated by a user's encrypted cookies for realtime authorization for any meaningful functionality (accessing client-only data, viewing admin screens, etc.)
    The front-end app is only responsible for adjusting the user experience based on what the server says the user's entitlements are. Even if the user somehow manages to enable an entitlement (e.g. show the GeoAnalyzer upload screen), actually uploading something to geoanalyzer should be denied by the server.
    Basically: think of this callback not as access control but as enabling the user to authenticate to allow the server to do access control
  */
  let params = new URLSearchParams(window.location.search)
  let embed = false
  if (params) {
    embed = params.get('embed')
    if(embed && embed == 'true') {
      document.cookie = 'embed=true'
    }
  }
  if (!to.meta.isPublic) {
    if (store.getters.isAuthenticated) {
      next()
    } else if ('development' == process.env.VUE_APP_MODE) {
      /* in dev mode, send the user to a fake login page where they'll be able to pick a user */
      if ('/mock-login' == to.path) {
        next()
      } else {
        router.push('/mock-login')
      }
    } else {
      if (embed) {
        window.location.replace(process.env.EMBED_VUE_APP_AUTH_HOST)
      } else {
        window.location.replace(process.env.VUE_APP_AUTH_HOST)
      }
    }
  } else {
    // this happens when the route metadata is marked as public
    next()
  }
  store.dispatch('clearSelectedProperty')
})

export default router
